import { UserType, UserTypeName } from "@declarations/common/enums/UserType";
import { GridValueFormatterParams } from "@mui/x-data-grid-pro";

const roleFormatter = ({ value }: GridValueFormatterParams) => (value && UserTypeName[value as UserType]) || value;

export default roleFormatter;